import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'primeng/components/common/api';
import { DESABILITAR_MENU_ATUALIZAR_INFORMACOES_CONTATOS } from '../../../../app.constants';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { ContatoRecuperarAcesso } from '../../dominios/contato-recuperar-acesso';
import { FilterDefaultService } from '../../services/filter-default.service';
import { FuncoeslimparFormatacao } from '../../util/funcoes-limpar-formatacao';
import { StorafeUtil } from '../../util/storasge.util';
import { EnderecoCentrusService } from '../../services/endereco-centrus.service';
import { EnderecoCadastroService } from '../../services/endereco-cadastro.service';
import { EnderecoSchemaCentrusModel } from '../../models/endereco-schema-centrus.model';
import { EnderecoSchemaCadastroModel } from '../../models/endereco-schema-cadastro.model';
import { EmailPessoaModel } from '../../models/email-pessoa.model';
import { TelefonePessoaModel } from '../../models/telefone-pessoa.model';
import { EnderecoTelaModel } from '../../models/endereco-Tela.model';
import { MessageUtil } from '../../messages/messageUtil';
import { IdentificacaoLoginDTO } from '../../models/identificacaoLogin-DTO';
import { LoginUsuarioDTO } from '../../models/login-usuarioDTO';


@Component({
  selector: 'app-atualizar-email-fone',
  templateUrl: './atualizar-email-fone.component.html',
  styleUrls: ['./atualizar-email-fone.component.css']
})
export class AtualizarEmailFoneComponent implements OnInit {

  @Input() display: boolean;


  enderecoSchemaCentrusModel = new EnderecoSchemaCentrusModel();
  enderecoSchemaCadastroModel = new EnderecoSchemaCadastroModel();
  emailPessoaModel = new EmailPessoaModel();
  telefonePessoaModel = new TelefonePessoaModel();
  enderecoTelaModel = new EnderecoTelaModel();


  identificacaoLoginDTO: IdentificacaoLoginDTO[] = [];


  loginUsuario = new LoginUsuarioDTO();

  msgs: Message[] = [];

  contatosForm: FormGroup;

  description: string;

  contatoRecuperarAcesso = new ContatoRecuperarAcesso()

  constructor(
    private filterDefaultService: FilterDefaultService,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService,
    private enderecoCadastroService: EnderecoCadastroService,
    private enderecoCentrusService: EnderecoCentrusService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this.contatosForm = this.fb.group({
      'dsEmail': new FormControl('', Validators.compose([Validators.required, Validators.email])),
      'nrFone': new FormControl('', Validators.compose([Validators.required, Validators.minLength(15)])),
    });
  }

  onSubmit(value) {
    this.contatoRecuperarAcesso = new ContatoRecuperarAcesso(
      Number(this.authInterceptor.getJwtCdCentrus()), this.contatosForm.value.dsEmail,
      Number(FuncoeslimparFormatacao.limparDados(this.contatosForm.value.nrFone)));
    try {
      this.updateDadosEnderecoSchemaCentrus()
      this.updateDadosTelefoneSchemaCadastro()
      this.updateDadosEmailSchemaCadastro()
      this.putLoginUsuario()
      this.putIdentificaoLogin()
      this.filterDefaultService.postUpdateContatos(this.contatoRecuperarAcesso);
      this.toastrService.success('Dados atualizados com sucesso.', 'Informativo', { timeOut: 4000 });
      this.display = false;
      StorafeUtil.limparSessionStorage(DESABILITAR_MENU_ATUALIZAR_INFORMACOES_CONTATOS);
      this.msgs = [];
    } catch (error) {
      console.error(error);
      this.toastrService.error('Dados não foram atualizados.', 'Informativo', { timeOut: 4000 });
      this.msgs = [];
    }
  }


  putLoginUsuario(): void {

    try {
      this.loginUsuario.cdCentrus = this.authInterceptor.getJwtCdCentrus();
      this.loginUsuario.irAtivo = true;
      this.loginUsuario.nrFone = Number(this.contatosForm.value.nrFone);
      this.enderecoCadastroService.putLoginUsuario(this.loginUsuario, this.loginUsuario.cdCentrus)

    } catch (error) {
      this.toastrService.error(MessageUtil.ERROR_UPDATE_REGISTRO, 'Error', { timeOut: 8000 })
    }

  }

  putIdentificaoLogin(): void {

    if (this.identificacaoLoginDTO[0]) { this.identificacaoLoginDTO[0].cdLogin = this.contatosForm.value.dsEmail }

    try {
      this.enderecoCadastroService.putIdentificaoLogin(this.identificacaoLoginDTO);

    } catch (error) {
      this.toastrService.error(MessageUtil.ERROR_UPDATE_REGISTRO, 'Error', { timeOut: 8000 })
    }

  }



  async updateDadosEnderecoSchemaCentrus() {
    this.enderecoSchemaCentrusModel = this.enderecoSchemaCentrusModel;

    this.enderecoSchemaCentrusModel.cdCentrus = this.authInterceptor.getJwtCdCentrus();
    this.enderecoSchemaCentrusModel.nrDdd1Celular = Number(FuncoeslimparFormatacao.limparDados(this.contatosForm.value.nrFone).substr(0, 2));
    this.enderecoSchemaCentrusModel.nrCelular1 = Number(FuncoeslimparFormatacao.limparDados(this.contatosForm.value.nrFone).substr(2));
    this.enderecoSchemaCentrusModel.dsEMail1 = this.contatosForm.value.dsEmail;

    try {
      this.enderecoCentrusService.updateEnderecoContatos(this.enderecoSchemaCentrusModel);
    } catch (error) {
      this.toastrService.error(MessageUtil.ERROR_UPDATE_REGISTRO, 'Error', { timeOut: 8000 })
    }


  }

  async updateDadosTelefoneSchemaCadastro() {


    this.telefonePessoaModel.cdCentrus = this.authInterceptor.getJwtCdCentrus();
    this.telefonePessoaModel.cdCentrusAlt = this.authInterceptor.getJwtCdCentrus();
    this.telefonePessoaModel.irFonePessoa = '1';
    this.telefonePessoaModel.nrDdd = Number(FuncoeslimparFormatacao.limparDados(this.contatosForm.value.nrFone).substr(0, 2));
    this.telefonePessoaModel.nrFone = Number(FuncoeslimparFormatacao.limparDados(this.contatosForm.value.nrFone).substr(2));

    try {
      this.enderecoCadastroService.updateTelefone(this.telefonePessoaModel);
    } catch (error) {
      this.toastrService.error(MessageUtil.ERROR_UPDATE_REGISTRO, 'Error', { timeOut: 8000 })
    }
  }



  async updateDadosEmailSchemaCadastro() {

    this.emailPessoaModel.cdCentrus = this.authInterceptor.getJwtCdCentrus();
    this.emailPessoaModel.cdCentrusAlt = this.authInterceptor.getJwtCdCentrus();
    this.emailPessoaModel.irRedeSocial = '1';
    this.emailPessoaModel.dsEmail = this.contatosForm.value.dsEmail;

    try {
      this.enderecoCadastroService.updateEmail(this.emailPessoaModel);
    } catch (error) {
      this.toastrService.error(MessageUtil.ERROR_UPDATE_REGISTRO, 'Error', { timeOut: 8000 })
    }

  }


  showDialog() {
    this.display = true;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/atualizar-email-fone/atualizar-email-fone.component.ts